import React, { FC } from 'react';
import styled from 'styled-components';
import { transProvablyFair } from '../../../pages/provablyFair.page/provablyFair.page';

export const ProvableFairOverview: FC = () => {
	return (
		<>
			<ProvableFairOverviewTitleStyled>
				{transProvablyFair({ label: 'Fairness' })}
			</ProvableFairOverviewTitleStyled>
			<ProvableFairOverviewParagraphStyled>
				{transProvablyFair({
					label:
						'Wolfbet uses a cryptographic provably fair algorithm which allows users to check and analyze the legitimacy of every bet and confirm they are not manipulated. Our random numbers are generated through the use of two seeds (a server seed and a client seed) and nonce number.',
				})}
			</ProvableFairOverviewParagraphStyled>
			<ProvableFairOverviewTitleStyled>
				{transProvablyFair({ label: 'Server seed' })}
			</ProvableFairOverviewTitleStyled>
			<ProvableFairOverviewParagraphStyled>
				{transProvablyFair({
					label:
						'After registration user is provided with an encrypted hash of that generated server seed. We provide you the hashed server seed to ensure that it cannot be changed by casino provider and that the player cannot calculate result beforehand. To verify your previous bets you have to reveal the server seed from its hashed version by generating new server seed in "Session" menu.',
				})}
			</ProvableFairOverviewParagraphStyled>
			<ProvableFairOverviewTitleStyled>
				{transProvablyFair({ label: 'Client seed' })}
			</ProvableFairOverviewTitleStyled>
			<ProvableFairOverviewParagraphStyled>
				{transProvablyFair({
					label:
						'The client seed is used to ensure the player also has influence on the randomness of the bets results. Player is free to  change their client seed anytime to create a new chain of random upcoming results. This ensures the player has absolute control over the generation of the result.',
				})}
			</ProvableFairOverviewParagraphStyled>
			<ProvableFairOverviewTitleStyled>
				{transProvablyFair({ label: 'Nonce' })}
			</ProvableFairOverviewTitleStyled>
			<ProvableFairOverviewParagraphStyled>
				{transProvablyFair({
					label:
						'The nonce is simply a number that increments every new bet and it is reset back while the server seed is changed. This value allows to create a completely new result each time, without having to generate a new client seed and server seed.',
				})}
			</ProvableFairOverviewParagraphStyled>
		</>
	);
};

export const ProvableFairOverviewTitleStyled = styled.h4.attrs({
	className: 'user-select-text text-style-md-medium',
})``;
export const ProvableFairOverviewParagraphStyled = styled.p.attrs({
	className: 'user-select-text text-style-md-regular',
})``;
